(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["book-an-appointment-step1"]) return;
  try {
    
const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const time = [10, 11, 12, 13, 14, 15, 16, 17, 18];
const TODAY = dayjs().format("YYYY-MM-DD");

const INITIAL_YEAR = dayjs().format("YYYY");
const INITIAL_MONTH = dayjs().format("M");

let googleCalendarData;
let initialMonth = dayjs(new Date(INITIAL_YEAR, INITIAL_MONTH - 1, 1));
let selectedMonth = dayjs(new Date(INITIAL_YEAR, INITIAL_MONTH - 1, 1));
let currentMonthDays;
let previousMonthDays;
let nextMonthDays;

const daysOfWeekElement = document.getElementById("days-of-week");

WEEKDAYS.forEach((weekday) => {
    const weekDayElement = document.createElement("li");
    daysOfWeekElement.appendChild(weekDayElement);
    weekDayElement.innerText = weekday;
});


$.when(getDateDataFromCalender()).done(function (res) {
	
    if (res.result == "success") {
    	
		googleCalendarData = formatApiTime(res.data);
		console.log(googleCalendarData);
        createCalendar();
        initMonthSelectors();

    } else {
    	googleCalendarData = new Array();
    }


});

function formatApiTime(googleCalendarData) {
    for (var [key, value] of Object.entries(googleCalendarData)) {
		let timeObj = {}
		let timeArr = value;
      	timeArr.forEach((timeRange) => {
			let bothTimes = timeRange.split(' - ');
			let startTime = bothTimes[0];
			let endTime = bothTimes[1];
			
			let startHours = parseInt(startTime.split(':')[0]);
			let ampm = startTime.split(' ')[1];
			if(ampm === "pm" && startHours!==12)
				startHours+=12;

			let endHours = parseInt(endTime.split(':')[0]);
			let endMins = parseInt(endTime.split(':')[1]);
			ampm = endTime.split(' ')[1];
			if(ampm === "pm" && endHours!==12)
				endHours+=12;
			if(ampm === "am" && endHours==0 && endMins==0)
				endHours = 24;
			if(endMins>0)
				endHours+=1;
			
			for(let i=startHours;i<endHours;i++)
            	timeObj[i] = 1;    
          	
      	});
		googleCalendarData[key] = timeObj
    }
	return googleCalendarData
}

function getDateDataFromCalender() {

        var response = new Array();

        var url = "https://script.google.com/macros/s/AKfycbyM0InBPY8sN-PP_yO2X9HAfHDnEIRucZXq2lCFn8VOzvF8EyIdWC15cP4GvpkBoY-WdQ/exec";
      
      	var date = new Date();

        var startDate = new Date();

        var endDate = new Date();
		endDate.setMonth(endDate.getMonth() + 4);
        endDate.setDate(0);


        return $.ajax({
            url: url + "?startDate=" + startDate + "&endDate=" + endDate,
            method: "GET",
            // data: data.serializeObject(),
            success: function (response) {

            }
        });

}


function canChangeMonth() {
    if (selectedMonth.month() <= initialMonth.month())
        document.getElementById("previous-month-selector").style.visibility = "hidden";
    else
        document.getElementById("previous-month-selector").style.visibility = "visible";

    if (selectedMonth.month() >= initialMonth.month() + 3)
        document.getElementById("next-month-selector").style.visibility = "hidden";
    else
        document.getElementById("next-month-selector").style.visibility = "visible";

}

function createCalendar(year = INITIAL_YEAR, month = INITIAL_MONTH) {
    const calendarDaysElement = document.getElementById("calendar-days");

    document.getElementById("selected-month").innerText = dayjs(
        new Date(year, month - 1)
    ).format("MMMM");
    removeAllDayElements(calendarDaysElement);

    currentMonthDays = createDaysForCurrentMonth(
        year,
        month,
        dayjs(`${year}-${month}-01`).daysInMonth()
    );
    previousMonthDays = createDaysForPreviousMonth(year, month);
    nextMonthDays = createDaysForNextMonth(year, month);

    const days = [...previousMonthDays, ...currentMonthDays, ...nextMonthDays];

    days.forEach((day) => {
        appendDay(day, calendarDaysElement);
    });

    canChangeMonth();
	initMobileButtons();
    initDateSelector();
}

function appendDay(day, calendarDaysElement) {
    var dayElement = document.createElement("li");

    const dayElementClassList = dayElement.classList;

    const dayOfMonthElement = document.createElement("span");
    dayOfMonthElement.innerText = day.dayOfMonth;
    dayElement.appendChild(dayOfMonthElement);
    if (day.dayOfMonth) {
        dayElementClassList.add("calendar-day");
        dayElementClassList.add("t8");
        dayElement.setAttribute('data-day', day.date);
		if(day.weekday == 0)
			dayElementClassList.add("booked");
		
    }
    calendarDaysElement.appendChild(dayElement);

    if (!day.isCurrentMonth) {
        dayElementClassList.add("calendar-day--not-current");
    }
	
	if (checkDateBooked(day.date)) {
        dayElementClassList.add("booked");
    }

}


function checkDateBooked(currentDate){
	var status = false;
	if (googleCalendarData.hasOwnProperty(currentDate)){
		for(var i=0;i<time.length;i++){
			status = checkTimeBooked(currentDate, time[i]);
            if(status===false)
               	return false;
     	}
        return true;
	}
    return false;   
}

function checkTimeBooked(currentDate, currentTime){
	if (googleCalendarData.hasOwnProperty(currentDate)) {
		if (googleCalendarData[currentDate].hasOwnProperty(currentTime))
        	return true;
    }
	return false;
}



function removeAllDayElements(calendarDaysElement) {
    let first = calendarDaysElement.firstElementChild;

    while (first) {
        first.remove();
        first = calendarDaysElement.firstElementChild;
    }
}

function getNumberOfDaysInMonth(year, month) {
    return dayjs(`${year}-${month}-01`).daysInMonth();
}

function createDaysForCurrentMonth(year, month) {
    return [...Array(getNumberOfDaysInMonth(year, month))].map((day, index) => {
        return {
            date: dayjs(`${year}/${month}/${index + 1}`).format("YYYY/MM/DD"),
            dayOfMonth: index + 1,
			weekday: getWeekday(dayjs(`${year}-${month}-${index + 1}`)),
            isCurrentMonth: true
        };
    });
}

function createDaysForPreviousMonth(year, month) {
    const firstDayOfTheMonthWeekday = getWeekday(currentMonthDays[0].date);

    const previousMonth = dayjs(`${year}-${month}-01`).subtract(1, "month");

    // Cover first day of the month being sunday (firstDayOfTheMonthWeekday === 0)
    const visibleNumberOfDaysFromPreviousMonth = firstDayOfTheMonthWeekday;

    const previousMonthLastMondayDayOfMonth = dayjs(currentMonthDays[0].date)
        .subtract(visibleNumberOfDaysFromPreviousMonth, "day")
        .date();

    return [...Array(visibleNumberOfDaysFromPreviousMonth)].map((day, index) => {
        return {
            date: dayjs(
                `${previousMonth.year()}-${previousMonth.month() + 1}-${
          previousMonthLastMondayDayOfMonth + index
        }`
            ).format("YYYY-MM-DD"),
            dayOfMonth: null,
            isCurrentMonth: false
        };
    });
}

function createDaysForNextMonth(year, month) {
    const lastDayOfTheMonthWeekday = getWeekday(
        `${year}-${month}-${currentMonthDays.length}`
    );

    const nextMonth = dayjs(`${year}-${month}-01`).add(1, "month");

    const visibleNumberOfDaysFromNextMonth = lastDayOfTheMonthWeekday ?
        7 - lastDayOfTheMonthWeekday :
        lastDayOfTheMonthWeekday;

    return [...Array(visibleNumberOfDaysFromNextMonth)].map((day, index) => {
        return {
            date: dayjs(
                `${nextMonth.year()}-${nextMonth.month() + 1}-${index + 1}`
            ).format("YYYY-MM-DD"),
            dayOfMonth: null,
            isCurrentMonth: false
        };
    });
}

function getWeekday(date) {
    return dayjs(date).day();
}

function initMonthSelectors() {
    document
        .getElementById("previous-month-selector")
        .addEventListener("click", function () {
            selectedMonth = dayjs(selectedMonth).subtract(1, "month");

            createCalendar(selectedMonth.format("YYYY"), selectedMonth.format("M"));
        });

    document
        .getElementById("next-month-selector")
        .addEventListener("click", function () {
            selectedMonth = dayjs(selectedMonth).add(1, "month");
            createCalendar(selectedMonth.format("YYYY"), selectedMonth.format("M"));
        });


}

function initMobileButtons() {
	var getStartedButton = document.getElementById("calendar-getstarted-btn");
	var getBackDateButton = document.getElementById("calendar-date-previous");
	var getBackTimeButton = document.getElementById("calendar-time-previous");
	var calendarInfoBox = document.getElementById("calendar-step1");
	var calendarDateBox = document.getElementById("calendar-step2");
	getStartedButton.addEventListener("click", function (event) {
        if(!calendarInfoBox.classList.contains("-ml-cal-block"))
        	calendarInfoBox.classList.add("-ml-cal-block")
	});
    getBackDateButton.addEventListener("click", function (event) {
            if(calendarInfoBox.classList.contains("-ml-cal-block"))
                calendarInfoBox.classList.remove("-ml-cal-block")
	});
	getBackTimeButton.addEventListener("click", function (event) {
            if(calendarDateBox.classList.contains("-ml-cal-block"))
                calendarDateBox.classList.remove("-ml-cal-block")
	});

	
}

function initDateSelector() {
    var days = document.getElementsByClassName("calendar-day");
	var calendarInfoBox = document.getElementById("calendar-step1");
	var calendarConfirmBtn = document.getElementById("calendar-confirmdate-btn");
    for (var i = 0; i < days.length; i++) {
       if(!days[i].classList.contains('booked')){
          days[i].addEventListener("click", function (event) {
              var selectedDate = $(this).data('day')
              var selectedMonth = dayjs(selectedMonth)
              $(this).addClass("active").siblings().removeClass('active');
              appointmentTime['date'] = selectedDate;
              document.getElementById("selected-date").innerHTML = dayjs(selectedDate).format("dddd, DD MMMM")
              initTimeSelector(selectedDate);
              if(!calendarInfoBox.classList.contains("-ml-cal-block"))
              		calendarInfoBox.classList.add("-ml-cal-block")
              calendarConfirmBtn.value = "Confirm "+dayjs(selectedDate).format("dddd, MMMM DD");
              calendarConfirmBtn.classList.remove("hidden");
          });
       }
    }
    var calendarConfirmBtn = document.getElementById("calendar-confirmdate-btn");
    var calendarDateBox = document.getElementById("calendar-step2");
    calendarConfirmBtn.addEventListener("click", function (event) {
		if(!calendarDateBox.classList.contains("-ml-cal-block"))
			calendarDateBox.classList.add("-ml-cal-block")
	});
}


function initTimeSelector(selectedDate) {

    
    const calendarTimesElement = document.getElementById("calendar-times");
    const calendarTimeBody = document.getElementById("appointment-calendar-time-body");
    calendarTimesElement.innerHTML = ""
    calendarTimeBody.style.height = document.getElementById("appointment-calendar-body").clientHeight + "px";
    for (var i = 0; i < time.length; i++) {
        var timeElement = document.createElement("li");

        const timeElementClassList = timeElement.classList;
        timeElementClassList.add("calendar-time");
        timeElementClassList.add("t8");

        const timeSpanElement = document.createElement("span");
        if (time[i] > 12)
            timeSpanElement.innerText = time[i] - 12 + " PM EST";
        else if (time[i] == 12)
            timeSpanElement.innerText = time[i] + " PM EST";
        else
            timeSpanElement.innerText = time[i] + " AM EST";

        timeElement.setAttribute('data-time', time[i]);
		
		if(checkTimeBooked(selectedDate,time[i]))
			timeElementClassList.add("booked");
		else{
          timeElement.addEventListener("click", function (event) {
              if ($(this).hasClass("active")) {
                  selectedTime = $(this).data('time')
				  appointmentTime['time'] = selectedTime;
				  let formattedTime = selectedTime;
				  if(selectedTime==12)
                      formattedTime = selectedTime+":00 pm"
                  else if(selectedTime>12)
                      formattedTime = (selectedTime-12)+":00 pm"
                  else
                      formattedTime = selectedTime+":00 am"
				  document.getElementById("detail-datetime").innerHTML = dayjs(appointmentTime.date).format("dddd, MMMM DD")+ " " + formattedTime+ " EST"
				  document.getElementById("confirmed-date").innerHTML = dayjs(appointmentTime.date).format("dddd, MMMM DD")+ ", at " + formattedTime+ " EST"

                  nextStep($(this))

              } else {
                  $("#confirm-time").remove();
                  $(this).addClass("active").siblings().removeClass('active');
                  var confirmElement = document.createElement("span");
                  confirmElement.id = "confirm-time";
                  confirmElement.innerText = "CONFIRM "
				  $(this).addClass("next");
                  $(this).prepend(confirmElement)
              }
          });
		}

        timeElement.appendChild(timeSpanElement);
        calendarTimesElement.appendChild(timeElement);
    }

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["book-an-appointment-step2"]) return;
  try {
    
$.fn.serializeObject = function () {
        var o = {};
        var a = this.serializeArray();
        $.each(a, function () {
            if (o[this.name]) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };

var form = $('form#book_appoint_form');
$('#book_appoint_form').on('submit',function(e) {
	e.preventDefault();
	var selectedDate = appointmentTime['date']
	var selectedTime = appointmentTime['time']
	if(selectedTime==12)
		selectedTime = appointmentTime['time']+":00 pm"
	else if(selectedTime>12)
		selectedTime = (appointmentTime['time']-12)+":00 pm"
	else
		selectedTime = appointmentTime['time']+":00 am"

	
	var appointmentData = form.serializeObject();
	appointmentData['Date_Time'] = selectedDate + " "+ selectedTime;

	var url = 'https://script.google.com/macros/s/AKfycbx7ITbrZq_7Op7kCmVbq7pmRl-f5uYJm7S-VI4FV3ck5ZiYRn4/exec';
  	$("#scheduleBtn").val("TRYING TO BOOK");
	$("#scheduleBtn").attr('disabled', true);
  
	$.ajax({
            url: url,
            method: "GET",
            dataType: "json",
            data: appointmentData,
            success: function (response) {
                nextStep(form)
            },
			error: function (response) {
                $("#scheduleBtn").val("Schedule Appointment");
				$("#scheduleBtn").attr('disabled', false);
            }
        });
	
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-template"]) return;
  try {
    
(function() {
  $('body').on('click', '.faq__question', function() {
    $(this).next('.faq__answer').slideToggle(150).toggleClass('active');
    $(this).toggleClass('active');
  });
  $(document).on('shopify:block:select', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
    $(event.target).find('.faq__answer').slideDown(150);
  });
  $(document).on('shopify:block:deselect', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
    $(event.target).find('.faq__answer').slideUp(150);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-section"]) return;
  try {
    
(function() {
  $('body').on('click', '.faq__question', function() {
    $(this).next('.faq__answer').slideToggle(150).toggleClass('active');
    $(this).toggleClass('active');
  });
  $(document).on('shopify:block:select', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
    $(event.target).find('.faq__answer').slideDown(150);
  });
  $(document).on('shopify:block:deselect', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
    $(event.target).find('.faq__answer').slideUp(150);
  });
}());

  } catch(e) { console.error(e); }
})();
})();
